<!--
 * @Author: chenxing
 * @Date: 2021-03-12 10:20:24
 * @LastEditors: LiuXin
 * @LastEditTime: 2022-01-05 10:38:43
-->
<template>
  <a-layout>
    <side-menu />
    <a-layout class="ant-layout-main">
      <layout-header />
      <!-- <a-layout-content :style="{ margin: '6px 10px', padding: '16px', background: '#fff', minWidth: '35rem', minHeight: 'unset' }"> -->
      <a-layout-content class="w100" style="overflow-x: auto !important; height: 200px; background: '#EFF3F7'">
        <div class="main_content w100 h100" :style="{ padding: '12px', minWidth: '35rem', minHeight: 'unset' }">
          <router-view />
        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import { defineComponent } from 'vue';
import sideMenu from './sideMenu';
import { notification, Button } from 'ant-design-vue';
import layoutHeader from './layoutHeader';

export default defineComponent({
  components: {
    sideMenu,
    layoutHeader,
  },
  data() {
    return {
      intervalTime: null,
    };
  },
  created() {
    this.intervalTime = null;
    this.intervalTime = setInterval(() => this.refreshVersion(), 60000);
    window.getVersion = version => {
      if (localStorage.frontendVersion && version != localStorage.frontendVersion) {
        const key = 'update';
        notification.info({
          message: '发现系统资源更新',
          description: '当前系统资源已更新，点击刷新按钮将刷新页面重新获取系统资源！',
          placement: 'bottomRight',
          duration: null,
          key,
          btn: (
            <Button type="primary" onClick={this.refreshHTML}>
              刷新
            </Button>
          ),
          style: { cursor: 'pointer' },
        });

        localStorage.newVersion = version;
      }
    };
  },
  methods: {
    refreshVersion() {
      let now = new Date().getTime();
      if (!localStorage.lastSyncVersionTime || now - localStorage.lastSyncVersionTime > 60000) {
        var versionScript = document.createElement('script');
        versionScript.src = location.origin + '/version.js?v=' + new Date().getTime();
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(versionScript, s);
        localStorage.lastSyncVersionTime = now;
      }
    },
    refreshHTML() {
      localStorage.frontendVersion = localStorage.newVersion;
      localStorage.removeItem('newVersion');
      location.reload();
    },
  },
});
</script>

<style lang="less">
.ant-layout-main {
  text-align: left;
  .trigger {
    font-size: 18px;
    line-height: 48px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
  }

  .trigger:hover {
    color: #1890ff;
  }

  .logo {
    height: 32px;
    background: rgba(255, 255, 255, 0.3);
    margin: 16px;
  }
}
.site-layout .site-layout-background {
  background: #fff;
}
</style>